import { ListOutlined, ViewAgendaOutlined } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

type SourcesViewToggleProps = {
  alignment: string | null;
  handleAlignment: (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => void;
};

const SourcesViewToggle = ({
  alignment,
  handleAlignment,
}: SourcesViewToggleProps) => {
  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
      size="small"
    >
      <Tooltip title="List view">
        <ToggleButton
          value="cardList"
          aria-label="card list"
          data-attr="assistant:toggle:sources-list-view"
        >
          <ListOutlined />
        </ToggleButton>
      </Tooltip>

      <Tooltip title="Data Chunk view">
        <ToggleButton
          value="dataChunk"
          aria-label="data chunk"
          data-attr="assistant:toggle:sources-chunk-view"
        >
          <ViewAgendaOutlined />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default SourcesViewToggle;
